export const data = {
    githubUsername : 'sahiljena',
    linkedin: 'https://www.linkedin.com/in/sahil-jena/',
    twitter: 'https://twitter.com/Sahiljena7',
    instagram: 'https://www.instagram.com/sahiljena_/',
    codechef : 'https://www.codechef.com/users/sahiljena',
    hackerrank : 'https://www.hackerrank.com/sahiljena46?hr_r=1'
}